import React from 'react'
import { t, Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { ButtonLink } from 'components/UI/ButtonLink/ButtonLink'
import { getColor } from 'components/utils'
import { Alert } from 'components/UI/Alert/Alert'

import { DotsVerticalIcon, MinusSmIcon } from '@heroicons/react/outline'
import { IdSalesState } from 'model/dashboardSales/dSalesReducer'
import {
    dSalesCheckedAllItemAC, dSalesCheckedItemAC,
    dSalesSetDetailItemAC
} from 'model/dashboardSales/dSalesActionCreators'
import { numberCurrencyFormat } from 'constants/convertToLocalCurrency';
import { getSalesTransStatus, SALESTATUS } from 'constants/salesStatus';
import { getIconPaymentType, getStringPaymentType } from 'constants/paymentType';
import { InputCheckbox } from 'components/UI/InputCheckbox/InputCheckbox';
import { WithTitle } from 'components/UI/WithTitle/withTitle';
import {typeDataSalesBulkActions} from "../index";


// Type
export type typeTableHeader = {
    variant?: string
    bulkOperations: typeDataSalesBulkActions
}

// Header data component
export const TableHeader: React.FC<typeTableHeader> = ({ variant, bulkOperations }) => {
    const dispatch = useDispatch()
    const color = getColor(variant)
    const tableData = useSelector((state: { dSales: IdSalesState }) => state.dSales.data)

    const groupActions = tableData.find(item => item.checked)

    const checkedAll = () => {
        dispatch(dSalesCheckedAllItemAC(true))
    }

    const unCheckedAll = () => {
        dispatch(dSalesCheckedAllItemAC(false))
    }
    return (
        <>{ !groupActions
            ? <>
                <th scope="col"
                    className="px-4 py-3  text-xs font-medium uppercase tracking-wider text-center">
                    <InputCheckbox id="selectAll" checked={ false } onChange={ () => checkedAll() }/>
                </th>
                <th scope="col"
                    className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider">
                    <Trans>Sale date</Trans> / <Trans>Receipt number</Trans>
                </th>
                <th scope="col"
                    className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                    <Trans>Store</Trans>
                </th>
                <th scope="col"
                    className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider ">
                    <Trans>Employee</Trans>
                </th>
                {/*<th scope="col"*/}
                {/*    className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider">*/}
                {/*    <Trans>Number of products</Trans>*/}
                {/*</th>*/}
                <th scope="col"
                    className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                    <Trans>Total amount</Trans>
                </th>
                <th scope="col"
                    className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                    <Trans>Credit</Trans> / <Trans>Prepayment</Trans>
                </th>
                <th scope="col"
                    className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                    <Trans>Payment method</Trans>
                </th>
                <th scope="col"
                    className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                    <Trans id="total_sales">Total</Trans>
                </th>
                <th scope="col"
                    className="px-4 py-3  text-left text-xs font-medium uppercase tracking-wider ">
                    <Trans>Refunds</Trans>
                </th>
                <th scope="col"
                    className="w-1 px-4 py-3 text-xs font-medium  uppercase tracking-wider text-center">

                </th>
            </>
            : <>
                <th scope="col"
                    className=" px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider text-center cursor-pointer">
                    <div className="flex justify-center" onClick={ () => unCheckedAll() }>
                        <div
                            className={ `flex flex-col justify-center items-center h-4 w-4 text-white focus:ring-white border border-gray-100 rounded bg-${ color }-600` }>
                            <div className="h-0.5 w-2 my-1 bg-white rounded"></div>
                        </div>
                    </div>
                </th>
                <th colSpan={ 9 } className="py-3 text-sm">
                    <div className="flex divide-x divide-gray-300">
                        { bulkOperations.map((item, index) => <div key={ index } ><WithTitle
                            titleText={ item.suggest }
                            component={
                                <ButtonLink dark={ true }
                                buttonClassName='px-3 font-medium text-gray-700'
                                type='button' label={ item.title }
                                onClick={ () => item.action() }/>
                            }
                        /></div>) }


                    </div>
                </th>
            </> }
        </>
    )
}


// Type
export type typeAction = {
    title: JSX.Element,
    disableSwitcher?: boolean,
    action: (id: string) => void,
}

export type typeTableBody = {
    variant?: string
    rowsActions: typeAction[]
    setOpenPopupDetails: React.Dispatch<React.SetStateAction<boolean>>
}


// Body data component
export const TableBody: React.FC<typeTableBody> = ({ variant, rowsActions, setOpenPopupDetails }) => {

    const color = getColor(variant)

    const dispatch = useDispatch()

    const tableData = useSelector((state: { dSales: IdSalesState }) => state.dSales.data)


    let component

    const onChangeSelectItemHandler = (id: string) => {
        dispatch(dSalesCheckedItemAC(id))
    }

    const onCellClickHandler = (e: React.MouseEvent<HTMLTableDataCellElement, MouseEvent>, id: string) => {
        dispatch(dSalesSetDetailItemAC(id))
        setOpenPopupDetails(true)
    }

    if (tableData.length) {
        component = tableData.map((item, index) => {
            const date = item.date ? item.date.substring(0, 19).replace('T', ' , ') : '-'


            return (
                <tr key={ item.id }
                    className={ `${ index % 2 === 0 ? 'bg-white' : 'bg-gray-50' } hover:bg-${ color }-50` }>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                        <div className="flex justify-center">
                            <InputCheckbox
                                id={ 'select-' + item.id }
                                checked={ item.checked }
                                onChange={ () => onChangeSelectItemHandler(item.id) }
                            />
                        </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ date } / { item.receiptNumber ? item.receiptNumber : '-' }</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm font-medium  text-gray-900 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }> { item.store?.name ? item.store.name :
                        <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm  text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.userName ? item.userName :
                        <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</td>
                    {/*<td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"*/}
                    {/*    onClick={ (e) => onCellClickHandler(e, item.id) }>{ "item.productList.length "}</td>*/}
                    <td className="px-4 py-3 whitespace-nowrap text-sm  text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.amount ? numberCurrencyFormat(item.amount) :
                        <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.status ? item.status === SALESTATUS.SALE ? '' : getSalesTransStatus(item.status) :
                        <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }</td>
                    <td className="px-4 py-3  whitespace-nowrap text-sm  text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>
                        <div className="flex flex-col justify-center divide-y">
                            { item.payments.length ? item.payments.map((it, index) => {
                                return (
                                    <div key={ index + item.id }>
                                        <p className=" flex gap-1" title={ getStringPaymentType(it.paymentType) }><span
                                            className="text-gray-500 flex gap-1 "
                                            title={ t`${ getStringPaymentType(it.paymentType) }` }>{ getIconPaymentType(it.paymentType) }{ it.paymentInfo?.paymentSystemName ? `  ${ it.paymentInfo.paymentSystemName }` : '' } </span>:<span
                                            className="text-gray-500 "> { numberCurrencyFormat(it.paymentAmount) }</span>
                                        </p></div>
                                )
                            }) : <div className="flex "><MinusSmIcon className="h-5 w-5 text-gray-400"/></div> }
                        </div>
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm  text-gray-500 cursor-pointer "
                        onClick={ (e) => onCellClickHandler(e, item.id) }>
                        <div className="">
                            { item.payments.length ? item.payments.reduce((sum, item) => sum + item.paymentAmount, 0)
                                .toLocaleString(undefined, {
                                    maximumFractionDigits: 2,
                                    minimumFractionDigits: 2
                                }) : '-' }
                        </div>
                    </td>
                    <td className="px-3 py-1sm:px-4 sm:py-3  whitespace-nowrap text-sm  text-gray-500 cursor-pointer"
                        onClick={ (e) => onCellClickHandler(e, item.id) }>{ item.refunded ?
                        <div className="flex"><Trans>Yes</Trans></div> : '' }</td>

                    <td className=" whitespace-nowrap text-sm text-gray-500 pr-2">
                        <div className="relative flex ">
                            <div
                                className="row-action-block">
                                <DotsVerticalIcon className="row-action-list-open-button"/>
                                <div className=" row-action-list">
                                    <div className="flex gap-x-4">
                                        { rowsActions.map((actionItem, ActionIndex) => {
                                                              return (
                                                                  <ButtonLink key={ ActionIndex + Math.floor(Math.random() * 10000) }
                                                                              type={ 'button' }
                                                                              label={ actionItem.title }
                                                                              onClick={ () => actionItem.action(item.id) }/>
                                                              )
                                                          }
                                        ) }
                                    </div>
                                </div>
                            </div>
                        </div>

                    </td>
                </tr>
            )
        })
    } else {
        component = <tr>
            <td className="p-2" colSpan={ 9 }>
                <Alert className="w-full" type={ 'info' }
                       title={ <Trans>The Sales list is empty. Check filters.</Trans> }/>
            </td>
        </tr>
    }

    return (
        <>
            { component }
        </>
    )
}
